// src/pages/FormPage/components/LogoutButton.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../firebase';
import { logoutAndRedirect } from '../../../utils/logoutAndRedirect';

/**
 * Exibe usuário logado e botão de logout como link
 */
const LogoutButton = () => {
  const location = useLocation();
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const name = user.displayName || user.email || 'usuário';
        setUserName(name);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    const currentParams = new URLSearchParams(location.search);
    const redirectUrl = `/login?${currentParams.toString()}&logout=true`;
    logoutAndRedirect(redirectUrl);
  };

  if (!userName) return null;

  return (
    <div className="flex justify-end mb-2 mr-1 text-xs text-gray-700">
      <span className="mr-1">
        Logado como <strong>{userName}</strong>. Não é você?{' '}
      </span>
      <button
        onClick={handleLogout}
        className="underline focus:outline-none p-0 m-0 bg-transparent border-none"
      >
        Clique aqui para sair
      </button>
    </div>
  );
};

export default LogoutButton;
